import { useState, useMemo } from 'react';
import { FaChevronLeft, FaChevronRight, FaSpinner } from 'react-icons/fa';
import useServiceCommissions from '../../../Hooks/Services/useServiceCommissions';
import Alert from '../../../Components/Alert';
import Modal from '../../../Components/Modal';
import UpdateServiceCommission from './UpdateServiceCommission';

const ServiceCommissions = () => {
    const [page, setPage] = useState(1);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [selectedCommission, setSelectedCommission] = useState(null);

    const queryParams = useMemo(() => ({
        page,
    }), [page]);

    const { commissions, total, loading, error, next, previous, refetch } = useServiceCommissions(queryParams);

    const handleEditClick = (commission) => {
        setSelectedCommission(commission);
        setIsEditOpen(true);
    };

    if (error) {
        return (
            <div className="p-6 bg-light min-h-screen font-cairo">
                <Alert
                    type="error"
                    message={error}
                    onClose={() => refetch()}
                />
            </div>
        );
    }

    if (loading && commissions.length === 0) {
        return (
            <div className="p-2 md:p-4 bg-light min-h-screen direction-rtl flex items-center justify-center">
                <div className="text-center">
                    <FaSpinner className="animate-spin text-main1 text-2xl mx-auto mb-4" />
                    <p className="text-main1 font-cairo">جاري تحميل البيانات ...</p>
                </div>
            </div>
        );
    }

    return (
        <>
            {/* الجدول */}
            <div className="overflow-x-auto rounded-2xl shadow-md bg-transparent">
                <table className="min-w-full text-sm text-main1 font-cairo">
                    <thead>
                        <tr className="bg-grayish text-main1">
                            <th className="p-4 text-center">اسم الخدمة</th>
                            <th className="p-4 text-center">نسبة العمولة</th>
                            <th className="p-4 text-center">إجراء</th>
                        </tr>
                    </thead>
                    <tbody>
                        {commissions.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="text-center py-8 text-gray-400">لا توجد بيانات متاحة</td>
                            </tr>
                        ) : (
                            commissions.map((commission) => (
                                <tr key={commission.id} className="border-b last:border-b-0 hover:bg-grayish/60 transition">
                                    <td className="p-4 text-center">
                                        <span className="font-bold text-main1">{commission.service}</span>
                                    </td>
                                    <td className="p-4 text-center">
                                        <span className="px-3 py-1 rounded-full text-xs font-bold bg-green-100 text-main1">
                                            {commission.commission}
                                        </span>
                                    </td>
                                    <td className="p-4 text-center">
                                        <button
                                            onClick={() => handleEditClick(commission)}
                                            className="px-4 py-2 rounded-full bg-main1 text-light hover:bg-main1/90 transition text-xs font-semibold"
                                        >
                                            تحديث
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* التصفح */}
            <div className="flex items-center justify-between mt-6">
                <div className="text-sm text-gray-500">عرض {commissions.length} من {total} خدمة</div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => setPage(p => Math.max(1, p - 1))}
                        className="p-2 rounded-3xl border border-gray-200 text-main1 disabled:opacity-50"
                        disabled={!previous}
                    >
                        <FaChevronRight />
                    </button>
                    <button
                        onClick={() => setPage(p => p + 1)}
                        className="p-2 rounded-3xl border border-gray-200 text-main1 disabled:opacity-50"
                        disabled={!next}
                    >
                        <FaChevronLeft />
                    </button>
                </div>
            </div>

            {/* Modal التحديث */}
            <Modal isOpen={isEditOpen} onClose={() => setIsEditOpen(false)} title="تحديث نسبة العمولة" size="md">
                <UpdateServiceCommission
                    commission={selectedCommission}
                    onSuccess={() => {
                        refetch();
                        setIsEditOpen(false);
                    }}
                />
            </Modal>
        </>
    );
};

export default ServiceCommissions;
